// automatically generated by the FlatBuffers compiler, do not modify

export enum TimeUnit {
  SECOND = 0,
  MILLISECOND = 1,
  MICROSECOND = 2,
  NANOSECOND = 3
}
